"use client";
import { useState } from "react";
import { Dialog } from "@headlessui/react";
import { AiOutlineClose } from "react-icons/ai";
import styles from "./DobDialog.module.css";
import { date } from "yup";
import { updateUserModel } from "@services/userAPI";
import Cookies from "js-cookie";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { getNames } from "country-list";
import { useEffect } from "react";

const DobDialog = ({
  title = "",
  message = "",
  user = {},
  handleSuccessDob,
  date,
  phoneNumber,
  gender,
  country,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [close, setClose] = useState(false);
  const [dob, setDob] = useState("");
  const [phone, setPhone] = useState("");
  const [selectedGender, setSelectedGender] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [errorDob, setErrorDob] = useState(false);
  const [errorGender, setErrorGender] = useState(false);
  const [errorPhone, setErrorPhone] = useState(false);
  const [errorCountry, setErrorCountry] = useState(false);
  //   const [successDob, setSuccessDob] = useState(false);
  useEffect(() => {
    Object.keys(user).length !== 0 &&
      console.log(
        isValidPhoneNumber(user.phoneNumber),
        user.country,
        user.country === ""
      );
  }, []);
  const closeModal = (e) => {
    // Add your logic to handle closing the dialog here
    setClose(false);
    // console.log("close", e);
  };
  // console.log(date, phoneNumber, gender, country);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (date && !isOlderThan18(dob)) {
      !isOlderThan18(dob) && setErrorDob(true);
      return;
    }
    if (phoneNumber && !isValidPhoneNumber(phone)) {
      !isValidPhoneNumber(phone) && setErrorPhone(true);
      return;
    }
    if (gender && selectedGender === "") {
      selectedGender === "" && setErrorGender(true);
    }
    if (country && selectedCountry === "") {
      selectedCountry === "" && setErrorCountry(true);
    }
    const formattedDate = formatDate(dob);
    // console.log(formattedDate);
    setIsLoading(true);
    const { status, data } = await updateUserModel(
      user.id,
      user.idToken,
      user.refreshToken,
      date ? formattedDate : user.dob,
      phoneNumber ? phone : user.phoneNumber,
      user.fname,
      user.lastName,
      user.username,
      country ? selectedCountry : user.country,
      "",
      gender ? selectedGender : user.gender
    );
    // console.log(status, data);
    if (status === "success") {
      console.log(data);
      Cookies.set(
        "user",
        JSON.stringify({
          id: data.uid,
          email: data.email,
          idToken: data.idToken,
          refreshToken: data.refreshToken,
          fname: data.fName,
          lastName: data.lastName,
          country: data.address,
          phoneNumber: data.phoneNumber,
          gender: data.gender,
          dob: data.bDate,
          updatedFields: data.updatedFields,
          username: data.userName,
          isPhoneVerified: data.isPhoneVerified,
        })
      );

      Cookies.set(
        "tokens",
        JSON.stringify({
          idToken: data.idToken,
          refreshToken: data.refreshToken,
        })
      );
      // console.log(user);
      handleSuccessDob();
    }

    // Add your logic to handle the case when the user is younger than 18

    setIsLoading(false);
  };
  //   const rerouting = () => {
  //     setIsLoading(true);
  //     mutate({ sessionID: sessionID });
  //     router.push(`/events/${eventID}`);
  //   };
  const isOlderThan18 = (dob) => {
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age >= 12;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return `${year}-${month}-${day}`;
  };
  const countries = getNames();
  return (
    <div className={styles.overlay}>
      <div className={`${styles.modal} ${false ? styles.fadeOut : ""}`}>
        <div as="h3" className={styles.title}>
          <span>{title}</span>
          {/* <span className={styles.btn} onClick={closeModal}>
            <AiOutlineClose className={styles.close} />
          </span> */}
        </div>
        <div as="div" className={styles.body}>
          <div style={{ width: "100%" }}>
            {/* <p className={styles.message}>{message}</p> */}
            <form action="" onSubmit={handleSubmit}>
              {date && (
                <div className={styles.dateBox}>
                  <input
                    className={styles.dob}
                    type="date"
                    name="dob"
                    id="dob"
                    value={dob}
                    onChange={(e) => setDob(e.target.value)}
                    required
                  />
                  {errorDob ? (
                    <p style={{ color: "red", fontSize: "12px" }}>
                      Must older than 12
                    </p>
                  ) : (
                    <></>
                  )}
                </div>
              )}
              {phoneNumber && (
                <div className={styles.phone_input}>
                  <PhoneInput
                    country={"us"}
                    value={phone}
                    onChange={(e) => {
                      // console.log(e);
                      setPhone(e);
                    }}
                    // inputStyle={{ width: "95%" }} // Set the input field width
                    // containerStyle={{ width: "100%" }} // Set the container width
                    // inputClass={styles["phone-input"]} // Apply custom styles
                    placeholder={"Your Phone Number"}
                    // buttonClass={styles["phone-flag"]}
                  />
                  {errorPhone ? (
                    <p style={{ color: "red", fontSize: "12px" }}>
                      Please Enter A Valid Phone Number
                    </p>
                  ) : (
                    <></>
                  )}
                </div>
              )}
              {gender && (
                <div className={styles.select_field}>
                  <select
                    className={styles.select}
                    value={selectedGender}
                    onChange={(e) => {
                      setSelectedGender(e.target.value);
                    }}
                  >
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                  {errorGender ? (
                    <p style={{ color: "red", fontSize: "12px" }}>
                      Please Select a Gender
                    </p>
                  ) : (
                    <></>
                  )}
                </div>
              )}
              {country && (
                <div className={styles.select_field}>
                  <select
                    className={styles.select}
                    value={selectedCountry}
                    onChange={(e) => {
                      // console.log(e.target.value);
                      setSelectedCountry(e.target.value);
                    }}
                  >
                    <option value="">Select Country...</option>
                    {Object.values(countries).map((country, index) => (
                      <option key={index} value={country}>
                        {country}
                      </option>
                    ))}
                  </select>
                  {errorCountry ? (
                    <p style={{ color: "red", fontSize: "12px" }}>
                      Please Select a Country
                    </p>
                  ) : (
                    <></>
                  )}
                </div>
              )}
              <div className={styles.btn_wrap}>
                <button disabled={isLoading} type="submit">
                  {isLoading ? "Loading.." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DobDialog;
